import React from "react";
import useForm from "rc-form-hooks";
import Input from "../../components/inputItem";

function Advisory() {

    const {getFieldDecorator, validateFields, errors, values} = useForm<{
        name: string,
        industry: string,
        city: string,
        contacts: string,
        phone:number,
        department:string
    }>();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(console.log)
            .catch(e => console.error(e.message));
    };

    return <div className="advisory-form">
        <form onSubmit={ handleSubmit }>
            {
                getFieldDecorator('name', {
                    rules: [{required: true, message: '请输入企业名称'}]
                })(<Input label='企业名称' placeholder='请输入企业名称' extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }

            {
                getFieldDecorator('industry', {
                    rules: [{required: true, message: '请输入所属行业'}]
                })(<Input label='所属行业' placeholder='请输入所属行业' extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }

            {
                getFieldDecorator('city', {
                    rules: [{required: true, message: '请输入所在城市'}]
                })(<Input label='所在城市' placeholder='请输入所在城市' extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }

            {
                getFieldDecorator('contacts', {
                    rules: [{required: true, message: '请输入企业联系人'}]
                })(<Input label='联 系 人' placeholder='请输入企业联系人' extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }

            {
                getFieldDecorator('phone', {
                    rules: [{required: true, message: '请输入联系电话'}]
                })(<Input label='联系电话' type={'number'} placeholder='请输入联系电话' extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }

            {
                getFieldDecorator('department', {
                    rules: [{required: true, message: '请输入所在部门'}]
                })(<Input label='所在部门' placeholder='请输入所在部门' extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }

            <button type={'submit'} className="common-btn submit">登录</button>

        </form>
    </div>
}

export default Advisory;
